import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import draggable from 'vuedraggable';
import store from '@/store';

import type { ListElements } from '@/typings/customilyElements/layer';
import LayersTreeItem from './LayersTreeItem.vue';
import LayersTreeItemEps from '@/components/Layers/tree/item/eps/LayersTreeItemEps.vue';
import LayersTreeItemGroup from '@/components/Layers/tree/item/group/LayersTreeItemGroup.vue';
import LayersTreeItemElement from '@/components/Layers/tree/item/element/LayersTreeItemElement.vue';
import { useLayersDraggable, type MoveEvent } from '@/components/Layers/composables/layerDraggable';
import { useLayerTreeItem } from '@/components/Layers/composables/useLayerTreeItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayersTreeItem',
  props: {
    value: null
  },
  emits: ["update:modelValue", "tree-item-moved"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:modelValue', value: ListElements[]): void;
    (event: 'tree-item-moved'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: ListElements;
};





const {
    pageEpsElements,
    dragOptions,
    handleMove,
    getItemKey,
    handleChange
} = useLayersDraggable();

const { isCollapsed, onCollapsedChanged } = useLayerTreeItem({
    item: props.value
});

const itemChildren = computed(() => props.value.children);
const hasChildren = computed(() => itemChildren.value && itemChildren.value.length > 0);

const isPageEps = computed(() => props.value.type === 'PageEps');
const shouldHideWrapper = computed(() => pageEpsElements.value && pageEpsElements.value?.length <= 1);

const forceShowIfOnlyHasOnePageEps = computed(() => isPageEps.value && shouldHideWrapper.value);

const itemComponent = computed(() => {
    const componentTypes = {
        PageEps: LayersTreeItemEps,
        Group: LayersTreeItemGroup,
        CanvasElement: LayersTreeItemElement,
        default: LayersTreeItemElement
    };

    return componentTypes[props.value.type] || componentTypes.default;
});

const toggleCollapse = () => {
    onCollapsedChanged(!isCollapsed.value);
};

const onMove = (event: MoveEvent) => {
    return handleMove(event);
};

const handleDragEnd = () => {
    emit('tree-item-moved');
    store.dispatch('storeLayers/setDraggedItem', {
        currentDraggedItem: undefined,
        currentTargetItem: undefined,
    });
};

const onChangeHandler = () => {
    handleChange();
};

const emitModelUpdate = (value: ListElements[]) => {
    emit('update:modelValue', value);
};

const getLayerId = (item: ListElements) => {
    return String(item.element?.uuid || item.element?.id || item.zIndex || '');
};

return { __sfc: true,props, emit, pageEpsElements, dragOptions, handleMove, getItemKey, handleChange, isCollapsed, onCollapsedChanged, itemChildren, hasChildren, isPageEps, shouldHideWrapper, forceShowIfOnlyHasOnePageEps, itemComponent, toggleCollapse, onMove, handleDragEnd, onChangeHandler, emitModelUpdate, getLayerId, draggable, LayersTreeItem }
}

})